import { AsyncValidatorFn } from '@angular/forms';

export function rateLimitValidator(blocked: boolean): AsyncValidatorFn {
  return (): any => {
    return blocked ? { blocked: true } : null;
  };
}
